import * as yup from "yup";

export const wantToInvestSchema = yup.object({
  value: yup
    .number()
    .typeError("Numero no valido")
    .min(5000, "La cantidad minima es $5,000")
    .required(),
});
